/* istanbul ignore file */
import RedirectEducation from './RedirectEducation';

export default RedirectEducation;
